import { MenuMobileBottom } from '@ui/Select/SelectInternalComponents/MenuMobileBottom';
import { MenuPortalMobileBottom } from '@ui/Select/SelectInternalComponents/MenuPortalMobileBottom';
import { MenuListMobileBottom } from '@ui/Select/SelectInternalComponents/MenuListMobileBottom';

import { GroupBase, SelectProps } from '../../types';
import { Select } from '../Select';

export function MobileBottomSelect<
Option,
IsMulti extends boolean,
Group extends GroupBase<Option>,
>(props: SelectProps<Option, IsMulti, Group>) {
  return (
    <Select
      isSearchable={false}
      components={{
        Menu: MenuMobileBottom,
        MenuPortal: MenuPortalMobileBottom,
        MenuList: MenuListMobileBottom,
        ...props.components,
      }}
      menuPortalTarget={document.body}
      {...props}
    />
  );
}
